import { reducer } from '@/helpers/async';
import { INVALIDATE as AUTH_INVALIDATE } from '@/store/actions/auth';
import { FETCH_NEAR_RIDES } from '@/store/actions/home';

const initialState = {
    nearRides: {}
};

export default (state = initialState, action) => {
    switch (action.type) {
        case AUTH_INVALIDATE:
        default:
            return {
                ...state,
                nearRides: reducer(FETCH_NEAR_RIDES)(state.nearRides, action)
            };
    }
};
